
module.exports = require('./socket');

/**
 * Exports parser
 *
 * @api public
 *
 */
module.exports.parser = require('engine.io-parser');



//////////////////
// WEBPACK FOOTER
// ./node_modules/engine.io-client/lib/index.js
// module id = ./node_modules/engine.io-client/lib/index.js
// module chunks = 0 1 2